export default "__VITE_ASSET__itMTPib3__"